import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { endpoints } from '../config';
import { SETPERMISSIONSV2 } from '../actions/auth';

export function RBACProvider({ children, isReady = true, } : { children: React.ReactNode; isReady?: boolean; }) {
  const [isPermissionsReady, setIsPermissionsReady] = useState(false);
  const dispatch = useDispatch();

  const fetchPermissions = async () => {
    const RBAC_ENDPOINT = `${endpoints.base_url}v1/rbac/me`;

    try {
      const { data } = await axios.get(RBAC_ENDPOINT);
      dispatch({ type: SETPERMISSIONSV2, permissionsV2: data.data.permissions });
    } catch (err: unknown) {

    } finally {
      setIsPermissionsReady(true);
    }
  };

  useEffect(() => {
    if (!isReady) {
      setIsPermissionsReady(false);
      return;
    }

    fetchPermissions();
  }, [isReady]);

  if (!isReady || !isPermissionsReady) return null;

  return <>{children}</>;
}

export default RBACProvider;
